import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTDialogFactory from "../../../ngt/dialog/NGTDialogFactory";
import NGTDialogPlayer from "../../../ngt/dialog/NGTDialogPlayer";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";

export default class PlayConversationStatementCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTDialogPlayer} dialogPlayer 
     * @param {NGTDialogFactory} dialogFactory 
     */
    constructor(dispatcher, dialogPlayer, dialogFactory) {
        super(dispatcher);

        this._dialogPlayer = dialogPlayer;
        this._dialogFactory = dialogFactory;
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {MeetingNotesContent} */
        const content = data.content;
        const contentPlayer = data.contentPlayer;

        this._dialogPlayer.setContentPlayer(contentPlayer);
        this._dialogPlayer.setContent(content);

        const dialogId = content.getLocationID();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        this._screenSkin = this.openScreen(SkinKeyRegistry.CONVERSATION_STATEMENT_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            dialogPlayer: this._dialogPlayer,
        });

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

        this._dialogPlayer.viewContent();
    }

    destroy() {
        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

        this._dialogPlayer.destroy();
        this._dialogPlayer = null;
    }

    _handleContentCompleted(evt) {
        const data = evt.params.data;
        const content = data.content;

        if (content !== this._dialogPlayer.getContent()) {
            return;
        }

        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

        this.closeScreen(this._screenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this.destroy();
    }
}